import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { Footer } from "../components/Footer";
import Navigator from "../components/Navigator";
import Typography from '@mui/material/Typography'
import { AddressForm } from "../components/AddressForm";
import { useContext, useEffect } from "react";
import { AppContext } from "../context";
import { Grid } from "@mui/material";

export default function AddressData() {
  const { lead, logo, plan, updateEvent } = useContext<any>(AppContext);
  useEffect(() => {
    console.log(lead)
    updateEvent({type: 'MQL', leadId: lead.leadId})
  }, [])

  return (
   
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        > 
         <Navigator step={1} />
          <Box >
            <img src={logo} alt=""  style={{margin: '4vh 0 0'}}/>
          </Box>
          <Typography sx={{color: 'primary.main', marginTop: '1vh'}}variant='h3'>
            Quase lá!
          </Typography>
          <Typography
           sx={{color: '#656565', marginTop: '2vh'}}
           variant='subtitle1'
           align='center'>
          Agora informe seu endereço
          </Typography>
          <Typography
           sx={{color: '#656565'}}
           variant='subtitle1'
           align='center'>
          Plano selecionado:
          </Typography>
          <Typography
           sx={{color: 'primary.main'}}
           variant='subtitle1'
           align='center'>
          <strong>{plan.plan_selected}: R$ {plan.price}</strong>
          </Typography>
          <AddressForm />
        </Box>
        <Box sx={{width:'100wv',
                  alignItems: "center"}}>
        <Footer />
        </Box>
      </Container>
  );
}
